import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Building2, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import herobg from '../../assets/images/hero.jpg';

const WelcomeCard = ({ hotel, room, guestName }) => {
  const backgroundImage = herobg;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card className="overflow-hidden border-0 bg-slate-900 shadow-2xl rounded-3xl">
        <CardContent className="relative min-h-[180px] p-0 sm:min-h-[250px]">
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 hover:scale-105"
            style={{
              backgroundImage: `url(${backgroundImage})`,
            }}
          />

          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

          <div className="relative z-10 flex min-h-[180px] flex-col justify-end p-5 text-white sm:min-h-[250px] sm:p-7">
            <div className="max-w-2xl space-y-2">
              <span className="inline-block text-[10px] font-bold uppercase tracking-[0.25em] text-white/80 sm:text-xs">
                Welcome to
              </span>

              <h2 className="text-xl font-extrabold leading-tight tracking-tight text-white sm:text-3xl md:text-4xl">
                {hotel?.name || 'InHimalayas Stay'}
              </h2>

              <div className="pt-1 flex flex-wrap items-center gap-2">
                {room?.roomNumber && (
                  <div className="inline-flex items-center gap-1.5 rounded-full border border-white/20 bg-white/15 px-3 py-1 text-xs font-semibold text-white backdrop-blur-md shadow-sm">
                    <Building2 className="h-3.5 w-3.5 text-[#f59e0b]" />
                    <span>Room {room.roomNumber}</span>
                  </div>
                )}

                {hotel?.location && (
                  <div className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-black/30 px-3 py-1 text-xs font-medium text-white/90 backdrop-blur-md">
                    <MapPin className="h-3.5 w-3.5 text-white/70" />
                    <span className="truncate max-w-[180px]">{hotel.location}</span>
                  </div>
                )}
              </div>

              {guestName && (
                <p className="pt-1 text-xs font-normal text-white/90 sm:text-sm">
                  Hello, <span className="font-bold text-white">{guestName}</span>
                  {room?.type && <span className="ml-1 text-white/70">• {room.type}</span>}
                </p>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default WelcomeCard;
